import Pagination from './pagination/zh_CN';
import DatePicker from './datePicker/zh_CN';
import TimePicker from './timePicker/zh_CN';
import Calendar from './calendar/zh_CN';

export default {
  locale: 'zh-cn',
  Pagination,
  DatePicker,
  TimePicker,
  Calendar,
  // locales for all comoponents
  global: {
    placeholder: '请选择',
  },
  Form: {
    switchControl: '切换控件',
  },
  Table: {
    filterTitle: '筛选',
    filterConfirm: '确定',
    filterReset: '重置',
    selected: '已选择',
    selectAll: '全选当页',
    selectInvert: '反选当页',
    sortTitle: '排序',
    expand: '展开行',
    collapse: '关闭行',
    term: '项',
    allData: '共',
    selectedAll: '选中全部'
  },
  Modal: {
    okText: '确定',
    cancelText: '取消',
    clearText: '清空',
    justOkText: '知道了',
  },
  Popconfirm: {
    cancelText: '取消',
    okText: '确定',
    removeFile: '删除文件',
  },
  Transfer: {
    searchPlaceholder: '请输入搜索内容',
    itemUnit: '项',
    itemsUnit: '项',
  },
  Download: {
    error: '下载失败',
    success: '下载成功',
    messageLink: '未识别到文件下载链接',
    messageRequest: '未识别到可用下载请求地址',
  },
  Upload: {
    error: '上传失败',
    success: '上传成功',
    uploading: '文件上传中',
    removeFile: '删除文件',
    uploadError: '上传错误',
    previewFile: '预览文件',
    downloadFile: '下载文件',
    downloadTemplate: '下载标准模板',
  },
  Empty: {
    description: '暂无相关数据',
  },
  Icon: {
    icon: '图标',
  },
  Text: {
    edit: '编辑',
    copy: '复制',
    copied: '复制成功',
    expand: '展开',
  },
  PageHeader: {
    back: '返回',
    loginOut: '退出登录',
  },
  Breadcrumb: {
    more: '更多',
  },
  ElectronicDocument: {
    upload: '电子文件上传',
  },
  SpeedDials: {
    title: '快捷应用',
  },
};
